import {
  type EntityListOfQuestDetail,
  postQuestsOverview,
  type QuestListRequest,
  type QuestOverview,
} from "Infrastructure/Api/Api";
import {
  type ApiCallError,
  processResponse,
} from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";
import { questKeys } from "./questKeys";

interface UseQuestQueryOptions {
  name?: string | null;
  offset?: number;
  limit?: number;
}

export const useQuestQuery = ({
  name = "",
  offset = 0,
  limit = 100,
}: UseQuestQueryOptions = {}) => {
  const query: QuestListRequest = {
    name,
    offset,
    limit,
  };

  return useQuery<QuestOverview, ApiCallError, EntityListOfQuestDetail>({
    queryKey: questKeys.list({ name, offset, limit }),
    queryFn: processResponse(({ signal }) =>
      postQuestsOverview(query, { signal }),
    ),

    select: (questOverview) => questOverview.quests,
  });
};
